import React, { useContext } from "react";
import { GlobalContext } from "../context/GlobalState";

import { css } from "emotion";
import { colors, boxStyles, textSizes } from "../styles/theme";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { withRouter } from "react-router-dom";
import spotlights from "../services/api/spotlights";

const TrashCan = ({ style, history }) => {
  const { currentSpotlight } = useContext(GlobalContext);

  const handleClick = async () => {
    try {
      const response = await spotlights.delete(currentSpotlight);
      history.push("/home");
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className={`${style ? style : ""} ` + container}>
      <button onClick={handleClick}>
        <FontAwesomeIcon icon="trash-alt" className="icon" />
        <p>DELETE</p>
      </button>
    </div>
  );
};

export default withRouter(TrashCan);

const container = css`
  button {
    cursor: pointer;
    width: 43px;
    height: 43px;
    border-radius: 50%;
    box-shadow: ${boxStyles.boxShadow};
    font-size: 14px;
    color: ${colors.cancel};
    outline: none;
    background-color: white;
    border: none;
    p {
      display: none;
    }
  }
  @media screen and (min-width: ${boxStyles.desktopBreak}) {
    width: 45%;
    button {
      width: 100%;
      border-radius: 40px;
      height: auto;
      padding: 12px 0;
      .icon {
        display: none;
      }
      p {
        display: block;
        font-size: ${textSizes.intermediate};
        font-weight: bold;
      }
    }
  }
`;
